import React, { Component } from 'react'
import { ALERT_SEVERITY } from '../../../components/AlertDisplay2';
import { APIData } from '../../../constants/APIAdresses';
import CollapsibleTile from '../../../components/CollapsibleTile';
import { Delete, Save } from '@mui/icons-material';
import { MUI_BTN_VARIANTS, MUI_COLORS } from '../../../constants/MUIConstants';
import SecretTextField from '../../../components/SecretTextField';
import { TextField } from '@mui/material';

export class PayPalTile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            paypalApiKey: "",
            paypalClientId:"",
            paypalApiKeyLoading: false,
            paypalDeleteDisabled: true,
        }
        this.paypalClientId = "";
        this.paypalApiKey="";
        this.paypalApiKeyId="";
        this.shopId = this.props.shopId;
    }
    loadPaypalApiKey() {
        const URI = APIData.USER + "/shop/" + this.shopId + "/getPaypalAPIKey";
        this.setState({ paypalApiKeyLoading: true });
        fetch(URI, { method: "GET", credentials: "include", headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                console.log("1111");
                if (response.status === 200) {
                    return response.json();
                } else if (response.status === 204) {
                    this.setState({
                        paypalApiKeyLoading: false
                    });
                } else {
                    throw new Error("Error while loading paypal api key: " + response.status);
                }
            }).then(result => {
                console.log("Paypal API Key: ", result);
                if (result?.apiKey && result?.id) {
                    console.log("Paypal API Key: ", result);
                    console.log("PUTTING IN STATE: ", (result.apiKey != null ? result.apiKey : ""));
                    this.setState({
                        paypalApiKeyLoading: false, paypalApiKey: result.apiKey != null ? result.apiKey : "", paypalClientId: result.clientId != null ? result.clientId : "", paypalDeleteDisabled: false,
                    });
                    this.paypalClientId = result.clientId;
                    this.paypalApiKey = result.apiKey;
                    this.paypalApiKeyId = result.id;
                } else {
                    this.setState({ paypalApiKeyLoading: false });
                }
            }).catch(e => {
                console.log("Error while loading paypal api key: ", e);
                this.setState({
                    paypalApiKeyLoading: false,
                });
                this.props.showAlert("Fehler beim Laden vom PayPal API-Key.", ALERT_SEVERITY.ERROR)
            })
    }
    addUpdatePaypalKey() {
        console.log("AddUpdatePaypalKey: ", this.state.paypalApiKey);
        this.setState({ paypalApiKeyLoading: true });
        fetch(APIData.USER + `/shop/${this.shopId}/addUpdatePaypalAPIKey`, { method: "PUT", credentials: "include", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ apiKey: this.state.paypalApiKey, clientId: this.state.paypalClientId }) })
            .then(response => {
                console.log("AddUpdateResponseStat: ", response.status);
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Error while adding/updating paypal api key: " + response.status);
                }
            }).then(result => {
                console.log("AddUpdateResult: ", result);
                if (result?.id) {
                    this.setState({
                        paypalApiKeyLoading: false,
                        paypalDeleteDisabled: false,
                    });

                    this.props.showAlert("Paypal API Key wurde erfolgreich gespeichert.", ALERT_SEVERITY.SUCCESS);
                    this.paypalApiKey = this.state.paypalApiKey;
                    this.paypalClientId = this.state.paypalClientId;
                    this.paypalApiKeyId = result.id;
                }
            }).catch(e => {
                console.log("Error while adding/updating paypal api key: ", e);
                this.setState({
                    paypalApiKeyLoading: false,
                })
                this.props.showAlert("Fehler beim Aktualisieren der PayPal Zugangsdaten.", ALERT_SEVERITY.ERROR);
            })
    }
    deletePaypalKey() {
        this.setState({ paypalApiKeyLoading: true });
        const showErr = () => {
            this.setState({
                paypalApiKeyLoading: false,
            });
            this.props.showAlert("Fehler beim Löschen der PayPal API-Key.", ALERT_SEVERITY.ERROR);
        }
        fetch(APIData.USER + `/deleteShopPaypalApiKey/${this.paypalApiKeyId}`, { method: "DELETE", credentials: "include" })
            .then(response => {
                if (response.ok) {
                    this.setState({
                        paypalApiKeyLoading: false, paypalApiKey: "", paypalClientId:"",  paypalDeleteDisabled: true,
                    });
                    this.props.showAlert("Paypal API Key wurde entfernt.", ALERT_SEVERITY.SUCCESS);
                    this.paypalApiKey = "";
                    this.paypalClientId = "";
                    this.paypalApiKeyId = "";
                } else {
                    console.log("Error while deleting paypal api key: ", response.status);
                    showErr();
                }
            }).catch(e => {
                console.log("Error while deleting paypal api key: ", e);
                showErr();
            })

    }
    render() {
        return (
            <CollapsibleTile
                onCollapseChange={(isExpanded, firstExpand) => {
                    if (isExpanded && firstExpand) {
                        this.loadPaypalApiKey()
                    }
                }}
                isLoading={this.state.paypalApiKeyLoading}
                actions={[
                    { label: "Löschen", icon: <Delete />, disabled: this.state.paypalDeleteDisabled, color: MUI_COLORS.ERROR, variant: MUI_BTN_VARIANTS.OUTLINED, onClick: () => { this.deletePaypalKey() } },
                    { label: "Speichern", disabled: this.state.paypalApiKey === this.paypalApiKey && this.state.paypalClientId === this.paypalClientId, icon: <Save />, onClick: () => { this.addUpdatePaypalKey() } },
                ]}
                title="PayPal API-Key" icon={<img src={require("../../../assets/icons/paypal_icon.png")} width={18} height={18} />}>
                <div style={{ display:"flex", flexDirection:"column", gap:15, width: "100%", }}>
                    <TextField label="Client-ID" value={this.state.paypalClientId} onChange={(evt) => {this.setState({paypalClientId: evt.target.value})}}/>
                    <SecretTextField label='API-Key' value={this.state.paypalApiKey} onChange={(value) => { this.setState({ paypalApiKey: value }) }} />
                </div>

            </CollapsibleTile>
        )
    }
}

export default PayPalTile